import { type ButtonHTMLAttributes, forwardRef } from 'react'
import { type VariantProps } from 'class-variance-authority'
import { cn } from '@/shared/utils/cn'
import { buttonVariants } from './button.variants'

export interface ButtonProps
  extends ButtonHTMLAttributes<HTMLButtonElement>,
    VariantProps<typeof buttonVariants> {}

export const Button = forwardRef<HTMLButtonElement, ButtonProps>(
  ({ className, variant, size, ...props }, ref) => (
    <button
      ref={ref}
      className={cn(buttonVariants({ variant, size }), className)}
      {...props}
    />
  ),
)
Button.displayName = 'Button'
